import { useLocalStorage } from './useLocalStorage';

export const useLocalAdminInfo = () => {
  return useLocalStorage('localAdminInfo', {
    token: '',
  });
};
